<template>
  <td class="table-roster-cell">
    <div
      class="wrp"
      v-tippy="{
        placement: 'bottom',
        content: `${count} Run Sheets`,
      }"
    >
      <template v-if="count">
        <ux-menu v-if="count > 1">
          <template #activator="{ on }">
            <ux-button size="xs" v-on="on" @click.stop icon>
              {{ count }}
            </ux-button>
          </template>
          <ux-panel>
            <ux-panel-body>
              {{ count }} Run Sheet{{ count === 1 ? "" : "s" }}
            </ux-panel-body>
            <ux-list>
              <ux-list-item
                @click="openRunsheet(item)"
                v-for="item in runsheets"
              >
                {{ item.title }}
                <!-- <ux-icon icon="fa-trash" left /> -->
                <!-- Delete {{ item.title }} -->
              </ux-list-item>
            </ux-list>
          </ux-panel>
        </ux-menu>

        <template v-else>
          <ux-button size="xs" icon @click.stop="openRunsheet(runsheets[0])">
            {{ count }}
          </ux-button>
        </template>
      </template>
      <template v-else>
        <div class="hover">
          <ux-button
            size="xs"
            icon
            :loading="creating"
            @click.stop="addRunsheet"
          >
            <ux-icon icon="fa-plus" />
          </ux-button>
        </div>
      </template>
    </div>
  </td>
</template>
<script>
import TableCellMixin from "./TableCellMixin.js";

export default {
  mixins: [TableCellMixin],
  data() {
    return {
      runsheets: [],
      creating: false,
    };
  },
  created() {
    this.runsheets = this.row.join_runsheet?.runsheet?.items || [];
  },
  methods: {
    async addRunsheet() {
      const self = this;
      self.creating = true;

      self.$sdk.global
        .create("runsheet", {
          model: {
            event: self.row,
          },
        })
        .then(
          function (model) {
            self.runsheets.push(model);
            self.openRunsheet(model);
            self.creating = false;
          },
          function (err) {
            self.creating = false;
          },
        );
    },
    async openRunsheet(item) {
      const canEdit = this.$sdk.access.canEditItem(this.user, item);
      console.log("OPEN", canEdit, item);
      if (canEdit) {
        return this.editRunsheet(item);
      } else {
        return this.viewRunsheet(item);
      }
    },
    async editRunsheet(item) {
      const result = await this.$sdk.global.edit(item, true);
      item.title = result.title;
    },
    async viewRunsheet(item) {
      const result = await this.$sdk.global.view(item, true);
      item.title = result.title;
    },
  },
  computed: {
    count() {
      return this.runsheets?.length;
    },
  },
};
</script>
<style scoped lang="scss">
td {
  &:hover {
    .hover {
      visibility: visible;
    }
  }
}

.wrp {
  text-align: center;
}

.hover {
  visibility: hidden;
}
</style>
